import { render } from "./expense.vue?vue&type=template&id=c1d227ea&scoped=true"
import script from "./expense.vue?vue&type=script&lang=js"
export * from "./expense.vue?vue&type=script&lang=js"

import "./expense.vue?vue&type=style&index=0&id=c1d227ea&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d227ea"]])

export default __exports__